export default __webpack_public_path__ + "static/tour-mob-4c310cde82999a7b0ff3148b6cd81390.jpg";